import React, {useEffect, useState} from 'react';
import NavBar from "../../Component/NavBar/NavBar";
import {IoIosAddCircleOutline} from "react-icons/io";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import {useNavigate} from "react-router-dom";
import toast from "react-hot-toast";
import noImage from "../../font & image/image/noImages.png";
import {Upload} from "lucide-react";
import axios from "axios";
import {FaTimes} from "react-icons/fa";
import {DndContext, closestCenter, PointerSensor, useSensor, useSensors,} from "@dnd-kit/core";
import {arrayMove, SortableContext, useSortable, verticalListSortingStrategy,} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {GripVertical} from "lucide-react";
import {restrictToVerticalAxis, restrictToParentElement} from "@dnd-kit/modifiers";


export default function Category() {

    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingDelete, setLoadingDelete] = useState(null);

    const [reorderedCategories, setReorderedCategories] = useState([]);
    const [orderChanged, setOrderChanged] = useState(false);
    const [savingOrder, setSavingOrder] = useState(false);

    const [showModalEdit, setShowModalEdit] = useState("")
    const [selectedCategoryOrder, setSelectedCategoryOrder] = useState("");
    const [selectedSpecifications, setSelectedSpecifications] = useState({});
    const [updateProduct, setUpdateProduct] = useState("")
    const [name, setName] = useState({
        name: "",
        fa_name: "",
        fr_name: "",
        de_name: "",
        zh_name: "",
        image: ""
    });
    const [CategoryID, setCategoryID] = useState("");
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {distance: 8},
        })
    );

    useEffect(() => {
        fetchCategories();
    }, [updateProduct, searchQuery]);

    const fetchCategories = () => {
        setLoading(true);
        const params = {
            is_paginate: false,
        };

        if (searchQuery) {
            params.search = searchQuery;
        }
        apiRequests.get(`/api/category/get-all-admin`, {params})
            .then((response) => {
                setCategories(response.data.data);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                console.error("Failed to fetch categories");
            })
            .finally(() => setLoading(false));
    };

    const handleDelete = (id) => {
        setLoadingDelete(id);

        apiRequests.delete("/api/category/delete-admin", {
            data: { id }
        })
            .then(() => {
                toast.success("Category deleted successfully");
                setCategories(prev => prev.filter(cat => cat._id !== id));
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("Failed to delete category");
            })
            .finally(() => {
                setLoadingDelete(null);
            });
    };


    const handleEdit = (id, category) => {
        setCategoryID(id)
        setName({
            name: category.name,
            fa_name: category.fa_name,
            fr_name: category.fr_name,
            de_name: category.de_name,
            zh_name: category.zh_name,
            image: category.image?.path,
        })
        setSelectedCategoryOrder(category.order)
        setSelectedSpecifications(category.specifications || {})
        setShowModalEdit(true)
    };

    const handleAdd = () => {
        navigate('/category/create');
    };

    const formatSpecifications = (specs) => {
        return Object.entries(specs || {}).map(([key, value]) => (
            <div key={key} className="text-xs">
                <span className="font-medium">{key}:</span> {value}
            </div>
        ));
    };

    const handleDragEnd = (event) => {
        const {active, over} = event;
        if (!over) return;

        if (active.id !== over.id) {
            const oldIndex = categories.findIndex(item => item._id === active.id);
            const newIndex = categories.findIndex(item => item._id === over.id);
            const newOrder = arrayMove(categories, oldIndex, newIndex);

            setCategories(newOrder);
            setOrderChanged(true);

            // ✅ فقط آرایه IDها به ترتیب جدید
            const updatedIds = newOrder.map(cat => cat._id);
            setReorderedCategories(updatedIds);
        }
    };


    const handleSaveOrder = async () => {
        if (reorderedCategories.length === 0) return;

        setSavingOrder(true);

        try {
            await apiRequests.patch("/api/category/Reorder", {
                categoryIds: reorderedCategories,
            });

            toast.success("Categories order updated successfully!");
            setOrderChanged(false);
            setReorderedCategories([]);
        } catch (error) {
            if (error.status === 401 || error.status === 403) {
                navigate("/login");
            }
            toast.error("Failed to update category order!");
        } finally {
            setSavingOrder(false);
        }
    };


    function SortableRow({category, handleEdit, handleDelete, formatSpecifications, index}) {
        const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id: category._id});

        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
            background: isDragging ? "#f3f4f6" : undefined,
        };

        return (
            <tr ref={setNodeRef} style={style} {...attributes} className="hover:bg-gray-100">
                <td {...listeners} className="px-4 py-4 text-gray-400 cursor-grab text-nowrap">
                    <GripVertical size={18}/>
                </td>
                <td className="px-6 py-4 text-nowrap">
                    <img
                        src={category.image ? `https://api.goalafarin.com/${category.image?.path}` : noImage}
                        alt={category.name}
                        className="w-16 h-16 object-cover rounded-lg"
                    />
                </td>
                <td className="px-6 py-4 text-gray-800 font-medium text-nowrap">{category.name}</td>
                <td className="px-6 py-4 text-gray-600 text-nowrap md:hidden">{category.parent?.name || 'None'}</td>
                <td className="px-6 py-4 text-gray-600 text-nowrap md:hidden">{formatSpecifications(category.specifications)}</td>
                <td className="px-6 py-4 text-nowrap md:hidden">
                <span className={`px-2 py-1 rounded-full text-xs font-medium 
                    ${category.isDeleted ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                    {category.isDeleted ? 'Deleted' : 'Active'}
                </span>
                </td>
                <td className="px-6 py-4 text-center text-nowrap">
                    <button
                        className="text-blue-500 hover:text-blue-700 font-medium mr-4"
                        onClick={() => {
                            handleEdit(category._id, category);
                            setSelectedCategoryOrder(index + 1);
                        }}
                    >
                        Edit
                    </button>
                    <button
                        className="text-red-500 hover:text-red-700 font-medium"
                        disabled={loadingDelete === category._id}
                        onClick={() => handleDelete(category._id)}
                    >
                        {loadingDelete === category._id ? <Loading textColor={'red-700'}/> : "Delete"}
                    </button>
                </td>
            </tr>
        );
    }

    return (
        <div className="p-6">
            <div className="text-3xl font-bold text-gray-800 mb-6">
                Category List
            </div>

            <NavBar item={[
                {icon: <IoIosAddCircleOutline/>, title: "Add Category", onClick: handleAdd},
            ]}
                    onSearch={(value) => {
                        setSearchQuery(value);
                    }}
            />
            {orderChanged && (
                <div className="flex justify-center mt-6">
                    <button
                        onClick={handleSaveOrder}
                        disabled={savingOrder}
                        className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-md disabled:bg-gray-400"
                    >
                        {savingOrder ? "Saving..." : "Confirm Order"}
                    </button>
                </div>
            )}


            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                        <thead className="bg-gradient-to-r from-purple-400 to-pink-500 text-white">
                        <tr>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Order</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Image</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Name</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap md:hidden">Parent</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap md:hidden">Specifications</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap md:hidden">Status</th>
                            <th className="px-6 py-3 text-center text-sm font-medium text-nowrap">Actions</th>
                        </tr>
                        </thead>

                        <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={handleDragEnd}
                            modifiers={[restrictToVerticalAxis, restrictToParentElement]}
                        >

                            <SortableContext
                                items={categories.map(c => c._id)}
                                strategy={verticalListSortingStrategy}
                            >
                                <tbody className="divide-y divide-gray-200">
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" className="px-6 py-4 text-center">
                                            <Loading/>
                                        </td>
                                    </tr>
                                ) : categories.length > 0 ? (
                                    categories.map((category, index) => (
                                        <SortableRow
                                            key={category._id}
                                            category={category}
                                            index={index}
                                            handleEdit={handleEdit}
                                            handleDelete={handleDelete}
                                            formatSpecifications={formatSpecifications}
                                        />
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
                                            No categories found
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </SortableContext>
                        </DndContext>

                    </table>

                </div>
            </div>

            {showModalEdit &&
                <ModalEdit setShow={setShowModalEdit} setUpdateProduct={setUpdateProduct} updateProduct={updateProduct}
                           categotyName={name} setName={setName} id={CategoryID} order={selectedCategoryOrder} specifications={selectedSpecifications}
                />}

        </div>
    );
}


export function ModalEdit({setShow, id, categotyName, setUpdateProduct, updateProduct, setName, order, specifications}) {


    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState("");
    const [loadingImage, setLoadingImage] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [localSpecifications, setLocalSpecifications] = useState(specifications || {});
    const [newSpecKey, setNewSpecKey] = useState("");
    const [newSpecValue, setNewSpecValue] = useState("");

    function readImage() {
        document.querySelector('#profile')?.click();
    }

    const navigate = useNavigate();
    function UploadImage(e) {

        const formData = new FormData();
        formData.append('file', e.target.files[0]);

        setLoadingImage(true)
        axios.post(`https://api.goalafarin.com/api/file/v1/upload-admin`, formData, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                "Content-Type": "multipart/form-data",
            },
        }).then((response) => {
            toast.success("Upload Image successfully");
            setImageUrl(URL.createObjectURL(e.target.files[0]));
            setImage(response.data.message._id)
        }).catch((error) => {
            if (error.status === 401 || error.status === 403) {
                navigate("/login");
            }
        }).finally(() => {
            setLoadingImage(false)
        })
    }

    function handleDeleteImage() {
        setImage("");
        setImageUrl("");
        setName({...categotyName, image: ""});
    }

    function EditCategory() {

        const payload = {
            CategoryId: id,
            name: categotyName.name,
            fa_name: categotyName.fa_name,
            fr_name: categotyName.fr_name,
            de_name: categotyName.de_name,
            zh_name: categotyName.zh_name,
            ...(image && {image}),
            order: order,
            specifications: localSpecifications
        }


        setLoading(true)
        apiRequests.patch(`/api/category/update-admin`, payload)
            .then((response) => {
                toast.success("successfully update category!")
                setUpdateProduct(!updateProduct)
                setShow(false)
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("Error updating category");
            })
            .finally(() => setLoading(false));

    }

    return (

        <div className="report-modal fixed inset-0 bg-black bg-opacity-60 transition-opacity">
            <div className="flex min-h-full items-end justify-center p-3 text-center">
                <div
                    className="modal relative text-black transform overflow-y-auto no-scrollbar rounded-lg bg-white p-8 w-[50%] md:w-[95%] m-auto flex flex-col gap-5 max-h-[90vh]"
                >
                    <button
                        onClick={() => {
                            setShow(false)
                        }}
                        className="hover:bg-red-200 w-fit rounded-full p-2 -mb-10 z-50"
                    >
                        <FaTimes size={25} className="text-red-600"/>
                    </button>

                    <div className="flex flex-col gap-5 text-gray-500 ">


                        <div className="mt-6 flex flex-col gap-2 items-center justify-center">
                            <label className="block mb-2 font-medium">Category Images *</label>
                            <div className="w-[60%]">

                                {(imageUrl || categotyName.image) ? (
                                    <div className="relative group">
                                        <img
                                            src={imageUrl || `https://api.goalafarin.com/${categotyName.image}`}
                                            alt="Preview"
                                            className="h-32 w-full object-contain rounded-lg border"
                                        />
                                        <button
                                            type="button"
                                            onClick={handleDeleteImage}
                                            className="absolute top-2 right-2 bg-white/80 p-1 rounded-full hover:bg-red-100"
                                        >
                                            <FaTimes className="w-4 h-4 text-red-600"/>
                                        </button>
                                    </div>
                                ) : (
                                    <label
                                        className="h-32 mt-3 border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer hover:border-indigo-500">
                                        {!loadingImage && (
                                            <input
                                                id="profile"
                                                type="file"
                                                accept="image/*"
                                                onChange={UploadImage}
                                                className="hidden"
                                            />
                                        )}
                                        <div className="text-center text-gray-500">
                                            {loadingImage ? (
                                                <div className="flex flex-col items-center gap-1">
                                                    <svg
                                                        aria-hidden="true"
                                                        className="w-5 h-5 animate-spin text-gray-500"
                                                        viewBox="0 0 100 101"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591..."
                                                            fill="currentColor"
                                                        />
                                                    </svg>
                                                    <span>Uploading...</span>
                                                </div>
                                            ) : (
                                                <>
                                                    <Upload className="mx-auto mb-1"/>
                                                    <span>Upload Image</span>
                                                </>
                                            )}
                                        </div>
                                    </label>
                                )}
                            </div>
                        </div>


                        <div>
                            <label className="block mb-2 font-medium text-left">Category Name ( English )</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded-lg"
                                value={categotyName.name}
                                onChange={e => setName({...categotyName, name: e.target.value})}
                            />
                        </div>

                        <div>
                            <label className="block mb-2 font-medium text-left">Category Name ( فارسی )</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded-lg"
                                value={categotyName.fa_name}
                                onChange={e => setName({...categotyName, fa_name: e.target.value})}
                            />
                        </div>

                        <div>
                            <label className="block mb-2 font-medium text-left">Category Name ( France )e</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded-lg"
                                value={categotyName.fr_name}
                                onChange={e => setName({...categotyName, fr_name: e.target.value})}
                            />
                        </div>

                        <div>
                            <label className="block mb-2 font-medium text-left">Category Name ( China )</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded-lg"
                                value={categotyName.zh_name}
                                onChange={e => setName({...categotyName, zh_name: e.target.value})}
                            />
                        </div>

                        <div>
                            <label className="block mb-2 font-medium text-left">Category Name ( Germany )</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded-lg"
                                value={categotyName.de_name}
                                onChange={e => setName({...categotyName, de_name: e.target.value})}
                            />
                        </div>

                        <div className="mt-4 w-full">
                            <label className="block mb-2 font-medium text-left">Specifications</label>

                            <div className="border rounded-lg p-3 bg-gray-50 space-y-2 max-h-40 overflow-y-auto">
                                {Object.entries(localSpecifications).map(([key, value]) => (
                                    <div key={key} className="flex gap-2 items-center">
                                        <input
                                            type="text"
                                            value={key}
                                            disabled
                                            className="w-1/3 p-1 border rounded text-sm bg-gray-100"
                                        />
                                        <input
                                            type="text"
                                            value={value}
                                            onChange={e =>
                                                setLocalSpecifications({
                                                    ...localSpecifications,
                                                    [key]: e.target.value
                                                })
                                            }
                                            className="w-2/3 p-1 border rounded text-sm"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const copy = { ...localSpecifications };
                                                delete copy[key];
                                                setLocalSpecifications(copy);
                                            }}
                                            className="text-red-500 font-bold px-1 rounded hover:bg-red-100"
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))}
                            </div>

                            {/* افزودن spec جدید */}
                            <div className="flex gap-2 mt-2">
                                <input
                                    type="text"
                                    placeholder="Key"
                                    value={newSpecKey}
                                    onChange={e => setNewSpecKey(e.target.value)}
                                    className="w-1/3 p-1 border rounded text-sm"
                                />
                                <input
                                    type="text"
                                    placeholder="Value"
                                    value={newSpecValue}
                                    onChange={e => setNewSpecValue(e.target.value)}
                                    className="w-2/3 p-1 border rounded text-sm"
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (!newSpecKey || !newSpecValue) return toast.error("Fill all Fields");
                                        setLocalSpecifications({
                                            ...localSpecifications,
                                            [newSpecKey]: newSpecValue
                                        });
                                        setNewSpecKey("");
                                        setNewSpecValue("");
                                    }}
                                    className="px-2 py-1 bg-green-500 text-white rounded hover:bg-green-600"
                                >
                                    Add
                                </button>
                            </div>
                        </div>


                    </div>

                    <div className="flex justify-center items-center gap-5 ">

                        <button
                            className="px-4 py-1 border-2 hover:bg-green-600 hover:text-white rounded-lg border-green-600 text-green-600"
                            onClick={EditCategory}
                        >
                            {loading ?
                                <Loading/>
                                :
                                "Edit"
                            }
                        </button>

                        <button className="hover:bg-gray-300 border-2 px-4 py-1 rounded-lg"
                                onClick={() => setShow(false)}>
                            Cancel
                        </button>

                    </div>
                </div>
            </div>
        </div>

    )
}